export const SORT_DROPDOWN_SORT_ORDER_BUTTON = 'sort-dropdown-sort-order-btn'
export const SORT_DROPDOWN_BUTTON = 'sortByButton'
